export const SET_ELCCONTROLLERS = 'ELCController/set';
export const SET_ELCCONTROLLERS_UPDATED = 'ELCController/UpdateStatus/set';
